import * as Yup from 'yup';

export const TextFieldModalSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, 'O valor deve conter no mínimo 2 caracteres.')
    .max(100, 'O valor deve conter no máximo 100 caracteres.')
    .required('Por favor, preencher o campo corretamente. O campo deve ter entre 2-100 caracteres.'),
  description: Yup.string()
    .max(100, 'O valor deve conter no máximo 100 caracteres.'),
  owner_id: Yup.string().email(),
});
